import React from "react";
import "../styles/bigtext.css";
import { useAudio } from "./AudioContext";

export default function BigText({
  text,
  align = "right",
  top = "auto",
  top2 = "auto",
}) {
  const { isMobile } = useAudio();

  return (
    <div
      className="bigtext"
      style={{
        top: isMobile ? top2 : top,
      }}
    >
      <h1
        className={
          align === "left" ? "left" : align === "center" ? "center" : "right"
        }
      >
        {text}
      </h1>
    </div>
  );
}
